/** @format */

import { z } from "zod";

export const resetPasswordSchema = z.object({
  email: z.string().min(1, "Required").email("Invalid email address"),
});

export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
